var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCheckmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.663 4.752a1 1 0 01.085 1.411l-11.52 13a1 1 0 01-1.418.08l-6.48-5.85a1 1 0 011.34-1.485l5.731 5.173 10.85-12.244a1 1 0 011.412-.085z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMS42NjMyIDQuNzUxNTlDMjIuMDc2NiA1LjExNzg3IDIyLjExNDcgNS43NDk4OSAyMS43NDg0IDYuMTYzMjNMMTAuMjI4NCAxOS4xNjMyQzEwLjA1MTUgMTkuMzYyOSA5LjgwMjA1IDE5LjQ4MzYgOS41MzU2NSAxOS40OTg1QzkuMjY5MjQgMTkuNTEzMyA5LjAwNzk2IDE5LjQyMTEgOC44MDk5MSAxOS4yNDIzTDIuMzI5OTEgMTMuMzkyM0MxLjkxOTk2IDEzLjAyMjIgMS44ODc2NSAxMi4zODk5IDIuMjU3NzQgMTEuOTc5OUMyLjYyNzgzIDExLjU3IDMuMjYwMTcgMTEuNTM3NyAzLjY3MDExIDExLjkwNzdMOS40MDA5NiAxNy4wODE0TDIwLjI1MTYgNC44MzY3OUMyMC42MTc5IDQuNDIzNDUgMjEuMjQ5OSA0LjM4NTMgMjEuNjYzMiA0Ljc1MTU5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPg==";
export { SvgIconCheckmark as ReactComponent };